export default __webpack_public_path__ + "static/media/search-1-1.b2d90adf.svg";